// Prevent events on a DOM overlay (friends panel, chat bar, …) from leaking to Phaser's
// window-level input handlers. Without this, keystrokes walk the player / get swallowed,
// and clicks pass through to canvas buttons underneath the overlay.
const KEY_EVENTS = ['keydown', 'keyup', 'keypress'];
const POINTER_EVENTS = [
  'pointerdown', 'pointerup', 'pointercancel', 'mousedown', 'mouseup', 'click',
  'touchstart', 'touchend', 'touchcancel', 'wheel',
];

const isTextField = (t) =>
  !!t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable);

// Listeners are added on the container in the BUBBLE phase, so the overlay's own
// buttons/inputs handle the event first; we only stop it from continuing up to window.
// Key events are stopped ONLY when typing in a text field — otherwise a button inside
// the overlay that still holds focus (e.g. just-clicked "Wyślij") would swallow the
// player's movement keys until they clicked elsewhere.
export function shieldFromPhaser(el, { keys = true, pointer = true } = {}) {
  const stop = (e) => e.stopPropagation();
  const stopIfTyping = (e) => { if (isTextField(e.target)) e.stopPropagation(); };
  if (keys) KEY_EVENTS.forEach((ev) => el.addEventListener(ev, stopIfTyping));
  if (pointer) POINTER_EVENTS.forEach((ev) => el.addEventListener(ev, stop));
}
